import React from 'react';
import styles from './FounderLetter.module.scss';

const LetterSVG = () => (
    <svg
        viewBox="0 0 160 160"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Founder letter illustration"
        className={styles.letterSvg}
    >
        {/* Envelope body */}
        <rect x="16" y="44" width="128" height="88" rx="8" fill="rgba(255,255,255,0.15)" stroke="rgba(255,255,255,0.4)" strokeWidth="2" />

        {/* Envelope flap (open, folded up) */}
        <path d="M16 52l64 46 64-46" stroke="rgba(255,255,255,0.5)" strokeWidth="2" fill="none" strokeLinejoin="round" />

        {/* Letter sheet sticking out above envelope */}
        <rect x="44" y="20" width="72" height="68" rx="5" fill="rgba(255,255,255,0.95)" />

        {/* Letter lines */}
        <line x1="56" y1="36" x2="104" y2="36" stroke="#1e0ea4" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="56" y1="48" x2="104" y2="48" stroke="#d0cce8" strokeWidth="2" strokeLinecap="round" />
        <line x1="56" y1="58" x2="96" y2="58" stroke="#d0cce8" strokeWidth="2" strokeLinecap="round" />
        <line x1="56" y1="68" x2="100" y2="68" stroke="#d0cce8" strokeWidth="2" strokeLinecap="round" />
        <line x1="56" y1="78" x2="88" y2="78" stroke="#d0cce8" strokeWidth="2" strokeLinecap="round" />

        {/* Red seal / stamp circle */}
        <circle cx="118" cy="76" r="12" fill="#FF5252" opacity="0.92" />
        <text x="118" y="80" textAnchor="middle" fontSize="10" fill="#fff" fontWeight="bold" fontFamily="sans-serif">P</text>

        {/* Bottom-right shadow accent */}
        <ellipse cx="80" cy="135" rx="44" ry="6" fill="rgba(12,5,109,0.15)" />
    </svg>
);

export default LetterSVG;
